module.exports = __webpack_public_path__ + "img/04_.238c6c76.png";